import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as itemsActions from 'store/modules/items';

import ItemDetailAcCt from 'components/items/ItemDetailAcCt';
// import ItemDetailArmmor from 'components/items/ItemDetailArmmor';

class ItemDetailAcCtContainer extends Component {

  componentDidMount() {
    
  }

  popupClose = () => {
    const {ItemsActions} = this.props;

    const isView = 'none';
    const itemSeq = '';
    ItemsActions.ctrlItemDtlPopup({isView, itemSeq});
  }

  ctrlAcCtUp = (e) => {
    const {ItemsActions, currSelAcCt} = this.props;
    const {optionView} = currSelAcCt.currItemOption;
    const currSel = 'currSelAcCt';
    const gubun = optionView === e.target.value ? '' : e.target.value;
    ItemsActions.setItemDetailOption({currSel, gubun});
  }

  setPowerup = (cnt) => {
    const {ItemsActions} = this.props;
    const currSel = 'currSelAcCt';
    ItemsActions.setPowerup({currSel, cnt});
  }

  render() {
    const {popupClose, setPowerup, ctrlAcCtUp} = this;
    const {currSelAcCt} = this.props;
    
    return (
      <ItemDetailAcCt 
        popupClose={popupClose}
        currSelAcCt={currSelAcCt}
        setPowerup={setPowerup}
        ctrlAcCtUp={ctrlAcCtUp}
      />
    );
  }
}

export default connect(
  (state) => ({
    currSelAcCt: state.items.toJS().currSelAcCt
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(ItemDetailAcCtContainer);